<script>
import { authMethods, authComputed } from '@state/helpers/auth.js'

export default {
    computed: {
        ...authComputed,
    },
    methods: {
        ...authMethods,
        callLogOut() {
            this.logOut()
            this.$router.push('/login')
        },
    },
}
</script>

<template>
    <div class="user__info">
        <b-dropdown variant="outline" no-caret>
            <template v-slot:button-content>
                <div class="user__info-button">
                    <b-img
                        v-if="currentUser.picture"
                        style="width: 38px; height: 38px"
                        rounded="circle"
                        class="user__info-picture mr-1"
                        :src="currentUser.picture"
                    />
                    <svgicon
                        v-else
                        height="38"
                        width="38"
                        name="icn_admin"
                        color="#fff"
                    />
                    <span>{{ currentUser.name }}</span>
                </div>
            </template>
            <b-dropdown-item
                id="profile"
                href="#"
                @click.prevent="$router.push('/my-profile')"
            >
                <div class="d-flex align-items-center">
                    <svgicon class="mr-3" name="icn_users" color="#009db8" />
                    {{ $t('Buttons.myProfile') }}
                </div>
            </b-dropdown-item>
            <b-dropdown-item
                id="profile"
                href="https://mgb.freshdesk.com/support/home/"
                target="_blank"
            >
                <div class="d-flex align-items-center">
                    <svgicon class="mr-3" name="icn_question" color="#009db8" />
                    {{ $t('Menu.faq') }}
                </div>
            </b-dropdown-item>
            <b-dropdown-item id="logout" href="#" @click.prevent="callLogOut">
                <div class="d-flex align-items-center">
                    <svgicon class="mr-3" name="icn_logout" color="#009db8" />
                    {{ $t('Buttons.exit') }}
                </div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/user-info';
</style>
